import {makeStyles} from '@material-ui/core/styles';
import {isMobileAppQuery, isSmSizeAppQuery} from 'lib/app-theme';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      minHeight: 74,
    },
    tooBarDark: {
      backgroundColor: theme.palette.primary.dark,
      margin: 'unset !important',
    },
    toolBarWithSpace: {
      padding: `0 ${theme.spacing(1.625)}px !important`,
      [isSmSizeAppQuery(theme)]: {
        padding: 'initial !important',
      },
    },
    toolBar: {
      height: '100%',
      paddingLeft: 0,
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: 'auto 0',

      ...theme.mixins.toolbar,

      '& .show-accessibility': {
        padding: 'unset',
      },

      '& .button-start': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    illustrationPrintTitle: {
      display: theme.withPrint('none', 'block'),
      paddingLeft: theme.forPrint(theme.spacing(4)),
    },
    hidePrint: {
      display: theme.forPrint('none'),
    },
    toolBarBox: {
      height: '100%',
    },
    toolBarBoxNoPadding: {
      '& .MuiListItem-root': {
        paddingTop: 'unset',
        paddingBottom: 'unset',
      },
    },
    nonAuthListItem: {
      textAlign: 'center',
      justifyContent: 'center',
      textTransform: 'uppercase',

      '& .MuiTypography-colorPrimary': {
        color: theme.palette.primary.dark,
      },
    },

    farList: {
      '& .MuiTypography-colorWhite': {
        color: theme.palette.common.white,
        whiteSpace: 'nowrap',
      },
      '& .MuiDivider-root': {
        backgroundColor: theme.palette.common.white,
      },
      [isMobileAppQuery(theme)]: {
        display: 'none',
      },
    },
    farListHeader: {
      '& .MuiTypography-root': {
        width: '100%',
        color: theme.palette.primary.dark,
      },
      '& .MuiListItem-root:hover .MuiTypography-root': {
        color: theme.palette.primary.main,
      },
    },

    logoImg: {
      maxHeight: 42,
      color: theme.palette.primary.dark,
    },
    divider: {
      height: '50%',
      alignSelf: 'center',
      backgroundColor: theme.palette.primary.dark,
    },
    dividerHorizontal: {
      height: theme.spacing(0.125),
      width: '100%',
    },
  }),
  {index: 1},
);

export default useStyles;
